import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ProductTag, TargetedOfferProductTag } from '@woolworthsnz/trader-api';
import { NgIf } from '@angular/common';

@Component({
	selector: 'product-fuel-tag',
	template: ` <img *ngIf="isFuelOffer" src="{{ fuelTag }}" alt="{{ offer?.offerValue }}" /> `,
	styleUrls: ['./fuel-tag.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [NgIf],
})
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export class FuelTagComponent {
	@Input() tag: ProductTag;

	get isFuelOffer(): boolean {
		if (!this.offer) {
			return false;
		}

		return this.offer.targetedOfferType === TargetedOfferProductTag.TargetedOfferTypeEnum.FuelCentsOff;
	}

	get offer(): TargetedOfferProductTag | undefined {
		return this.tag?.targetedOffer;
	}

	get fuelTag(): string | false {
		const deployUrl = '/assets/images/product-details/tags';
		return !!this.offer && `${deployUrl}/smart-fuel/fuel_${this.offer.offerValue}.png`;
	}
}
